const React = require('react');
const toLower = require('mn-utils/toLower');
const trim = require('mn-utils/trim');
const {
  LINK_DASHBOARD,
  LINK_BLOCKED,
  LINK_ADMIN_DASHBOARD,
  LINK_PASSWORD_FORGOT
} = require('../../../constants/links');
const {getAdminLink} = require('../../../utils/adminLinkCtor');
const {
  Link,
  replaceLocation,
} = require('../../../router');
const {
  login$,
  account$,
  onAccount, handleChangeEmail,
} = require('../../../emitters/account');

const Base = require('../../smart/Page/AuthLayout');
const {FormWrapper, FormSubmitBtn} = require("../../dumb/FormHandlers");
const {AuthInput, AuthInputPassword} = require("../../dumb/FormInputs");
const {object, string} = require("yup");

module.exports = () => {
  const schema = object({
    email: string().email().required(),
    password: string()
        .matches(
          /^[A-Za-z0-9_\-!&`2#$%@^*}{\[\]()=+?/\\'"<>.,|:;~]+$/,
          'Password must contain Latin letters, numbers and symbols'
        )
        .required()
  });

  const onSubmit = (data) => {
    return (
      account$.signIn({
        login: toLower(data.email),
        password: data.password,
      }).then((account) => {
        if (account.blocked) {
          replaceLocation({
            path: LINK_BLOCKED + encodeURIComponent(params.email) + '/',
          });
          return;
        }
        if (onAccount(account)) {
          return;
        }

        replaceLocation({
          path: account.admin
            ? getAdminLink(LINK_ADMIN_DASHBOARD)
            : LINK_DASHBOARD,
        });
      })
    )
  }

  return (
    <FormWrapper
      data={{email: login$.getValue() || ''}}
      schema={{default: schema}}
      onSubmit={onSubmit}
    >
      {(formCtx) => (
        <Base
          title="Login"
          content={(
            <>
              <div className="mb30">
                <AuthInput
                  label="Email"
                  name="email"
                  formCtx={formCtx}
                  onChangeHandlers={[trim, handleChangeEmail]}
                />
              </div>
              <div>
                <AuthInputPassword
                  label="Password"
                  name="password"
                  formCtx={formCtx}
                  onChangeHandlers={[trim]}
                />
              </div>
            </>
          )}
          beforeFooter={(
            <div className="ph25 pt15 pb35 lh18 lts0em">
              <Link
                href={LINK_PASSWORD_FORGOT}
                className="c5B47FF olN tdU dn f12 fw3 o70:h"
              >Forgot password?</Link>
            </div>
          )}
          control={(
            <FormSubmitBtn formCtx={formCtx}>
              Submit
            </FormSubmitBtn>
          )}
        />
      )}
    </FormWrapper>
  )
}
